import { CircularProgress, makeStyles } from "@material-ui/core";
import React from "react";

import { Box } from "../../../../../dtos/box";
import { useLogFilterRequest } from "../../../../../hooks/useLogFilterRequest";
import { LogFilterRequestSection } from "../../../../LogFilterRequestSection";
import { ReportLogTable } from "../../../events/ReportLogTable";

import { EVENT_TYPE_NAME_OPTIONS } from "./boxEventOptions";
import { useBoxEvents } from "./useBoxEvents";

const useStyles = makeStyles(() => ({
    header: {
        display: "flex",
        alignItems: "center",
        gap: "25px",
    },
    filterRow: {
        display: "flex",
        justifyContent: "start",
        alignItems: "flex-end",
        gap: "10px",
    },
}));

interface Props {
    box: Box;
}

export function BoxHistory({ box }: Props) {
    const classes = useStyles();

    const {
        request,
        formObj,
        setFormObj,
        resetFormObj,
    } = useLogFilterRequest();

    const {
        isLoading,
        events,
        numberOfPages,
    } = useBoxEvents(box, request);

    return (<>
        <div className={classes.header}>
            <h2>Box History</h2>
            {isLoading ? <CircularProgress size={20} /> : <></>}
        </div>

        <LogFilterRequestSection
            formObj={formObj}
            setFormObj={setFormObj}
            resetFormObj={resetFormObj}
            dealerId={undefined}
            organizationId={box.orgId}
            siteId={box.siteId}
            logTypeOptions={EVENT_TYPE_NAME_OPTIONS}
            numberOfPages={numberOfPages}
            paginationDisabled={isLoading}
            allowMultipleEventTypes={true}
        />

        <ReportLogTable
            events={events}
            filterByLocalTime={formObj.filterByLocalTime}
            isLoading={isLoading}
        />
    </>);
}
